/* eslint-disable */
import React, {useEffect, useState} from 'react'
import Modal from 'react-modal';
import ButtonV2 from 'components/ButtonV2';
// import ButtonSecondary from 'components/ButtonSecondary';
import {Link} from 'react-router-dom';

// scss
import './modalTnC.scss'
import userSvc from 'services/userSvc';
import authSvc from 'services/authSvc';
import { Alert, AlertType } from 'utils/Alert';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    padding: 0,
    width: '600px',
    height: '90%',
    overflow: 'hidden'
  },
};

function ModalTnC(props) {
  const { isModalAddTnC, setModalAddTnC } = props;
  const dataUser = authSvc.currentUser();
  const [isLoading, setLoading] = useState(false)
  const [securityRecomendation, setSecurityRecomendation] = useState({aggrement: false, receiveEmail: false})

  async function handleSaveModal(){
    if(securityRecomendation?.aggrement) {
     submitData(); 
    } else {
      Alert.showStatus(
        AlertType.WARNING,
        'Warning!',
        `You don't submitted aggrement Terms of Conditions`
      )
      setModalAddTnC({show: false})
    }
  }

  async function submitData(){
    setLoading(true);
    try {
      const params = {
        pp_version: '1.9',
        tnc_version: '1.2.2'
      }
      const aggrementTnCData = await userSvc.recordAggrementTnC(dataUser?.user?.id, params);
      
      if(aggrementTnCData?.data) {
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Terms of Conditions Submitted'
        )
        setModalAddTnC({show: false})
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  }

  return (
    <div>
      <Modal
        isOpen={isModalAddTnC.show}
        onRequestClose={() => setModalAddTnC({show: true})}
        style={customStyles}
        contentLabel="Example Modal"
      >
      <div className='h-100'>
        <div className='title_modal_tnc px-4 pt-4 pb-3'>
          <h3 className='fsize-16 cl-neutral400 fweight-600 ltr-spaccing-2 line-height-20 mb-1'>Pembaruan Perjanjian Layanan OCA</h3>
          <p className='mb-0 fsize-12 fweight-400 cl-grey-200 ltr-spaccing-2 line-height-20'>Geser ke bawah untuk meninjau dan menyetujui pembaruan.</p>
        </div>
          <div className="wrapper_body_tnc px-4 py-3" style={{height: '85%'}}>
            <div className='content mb-4' style={{height: '88%'}}>
                <p className='fsize-10 fweight-400 cl-grey-200 d-block mb-2 ltr-spaccing-2 line-height-20'>Terakhir diperbarui pada 21 November 2024.</p>
                <p className='fsize-12 fweight-400 cl-grey-primary d-block ltr-spaccing-2 line-height-20 mb-2'>
                  Mulai tanggal 16 Oktober 2024, kami memperbarui Syarat dan Ketentuan serta Kebijakan Privasi terkait perlindungan terhadap Data Pribadi Anda maupun Pengguna Anda (secara bersama-sama disebut sebagai "<strong>Data</strong>") dalam layanan OCA. Perubahan ini tidak berdampak negatif terhadap pengelolaan serta penggunaan layanan kami.
                </p>
                <p className='fsize-12 fweight-400 cl-grey-primary d-block mb-2 ltr-spaccing-2 line-height-20'>Ketahui ringkasan dari pembaruan persyaratan yang kami lakukan, di antaranya:</p>
                <ol className='fsize-12 fweight-400 cl-grey-primary ps-3 ltr-spaccing-2 line-height-20'>
                    <li className='mb-2'>
                        <strong>Perolehan dan Pengumpulan Data</strong> oleh OCA dibatasi hanya pada informasi yang sesuai dan relevan dengan penggunaan layanan, seperti nomor pelanggan, nomor kartu kredit/debit hingga setiap informasi lain atau gabungan informasi yang termasuk ke dalam kategori Data Pribadi yang digunakan untuk mengakses layanan OCA.
                    </li>
                    <li className='mb-2'>
                        <strong>Penggunaan Data</strong> akan kami proses sesuai dengan proses penggunaan layanan OCA yang Anda lakukan, personalisasi akun Anda pada halaman OCA, tujuan penagihan atas penggunaan layanan OCA dan sebagainya.
                    </li>
                    <li className='mb-2'>
                        <strong>Penyimpanan Data</strong>  di OCA melalui proses verifikasi dan enkripsi selama layanan OCA beroperasi. Kami akan menyimpan Data Anda paling lama 5 (lima) tahun sejak penggunaan terakhir Anda. Namun, Anda dapat mengajukan penghapusan atau pemusnahan Data sebelum jangka waktu tersebut.
                    </li>
                    <li className='mb-2'>
                        <strong>Perubahan dan Pembaruan Data</strong>  harus Anda lakukan melalui proses yang mendukung tujuan keamanan dan relevansi Data sebagai bentuk pencegahan tindakan kriminalitas.
                    </li>
                    <li className='mb-2'>
                        <strong>Keamanan dan Privasi Data</strong> hanya kami gunakan untuk keperluan penyelenggaraan layanan OCA dan tidak diserahkan, ditampilkan, atau diungkapkan kepada pihak ketiga tanpa persetujuan Anda.
                    </li>
                </ol>
                <p className='bottom_of_paragraph fsize-12 fweight-400 cl-grey-primary d-block mb-4 ltr-spaccing-2 line-height-20 pb-2'>
                    Silakan tinjau perjanjian layanan secara lengkap dan konfirmasikan persetujuan Anda untuk lanjut menggunakan layanan OCA.
                </p>

                <div className="item-dropdown-filter check-radio-red mb-2">
                    <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                        onChange={(e) => setSecurityRecomendation({...securityRecomendation, aggrement: e.target.checked})} 
                        // value={isSecurityRecomendation} 
                        // checked={isSecurityRecomendation}
                        name='security'/>
                    <label className='fsize-12 fweight-400 cl-grey-primary ltr-spaccing-2 line-height-20'>
                       Saya sudah membaca dan menyetujui pembaruan dari &nbsp;
                        <a 
                          href="https://ocaindonesia.co.id/en/termcondition"
                          target="_blank"                          
                          className='cl-red cursor-pointer fsize-12 fweight-700'>
                          Syarat & Ketentuan
                        </a> &nbsp;
                         serta &nbsp;
                          <a 
                            href="https://ocaindonesia.co.id/en/privacypolicy"
                            target="_blank"
                            className='cl-red cursor-pointer fsize-12 fweight-700'>
                            Kebijakan Privasi 
                        </a> &nbsp;
                         OCA. &nbsp;
                         <span>(Wajib)</span>
                    </label>
                </div>
                {/* <div className="item-dropdown-filter check-radio-red mb-2">
                    <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                        onChange={(e) => setSecurityRecomendation({...securityRecomendation, receiveEmail: e.target.checked})} 
                        // value={isSecurityRecomendation} 
                        // checked={isSecurityRecomendation}
                        name='security'/>
                    <label className='fsize-12 fweight-400 cl-grey-primary ltr-spaccing-2 line-height-20'>
                        Saya ingin menerima email terkait penawaran, promosi, dan informasi OCA lainnya. (Opsional)
                    </label>
                </div> */}

            </div>
            <div className='d-flex align-items-center justify-content-end w-45 ms-auto'>
              <ButtonV2 
                className='ms-2 ltr-spaccing-2 line-height-20'
                handleRoute={handleSaveModal} 
                backgroundColor="#E81255"
                textColor="#FFFFFF"
                padding=".360rem 1rem"
                disabled={isLoading || !securityRecomendation?.aggrement}
              >
                Konfirmasi Perubahan
              </ButtonV2>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalTnC